import sessionConstants from '../../constants/SessionConstants';

function getDataSetIdentifier(dataSetType, parameters) {
    const { assessmentRunId, assessmentRunContentId, contentItemId, contentRevisionId, sourceTemplateId } = parameters;
    if (dataSetType === sessionConstants.MODE_QUESTION || dataSetType === sessionConstants.MODE_SECTION) {
        return contentItemId
            ? { paramName: 'contentItemId', paramValue: contentItemId }
            : { paramName: 'contentRevisionId', paramValue: contentRevisionId };
    }

    if (assessmentRunContentId) {
        return { paramName: 'assessmentRunContentId', paramValue: assessmentRunContentId };
    } else if (assessmentRunId) {
        return { paramName: 'assessmentRunId', paramValue: assessmentRunId };
    } else if (contentItemId) {
        return { paramName: 'contentItemId', paramValue: contentItemId };
    } else if (contentRevisionId) {
        return { paramName: 'contentRevisionId', paramValue: contentRevisionId };
    } else if (sourceTemplateId) {
        return { paramName: 'sourceTemplateId', paramValue: sourceTemplateId };
    }

    return {};
}

class QuestionDataIdentifier {
    constructor(dataSetType, identifiers) {
        const identifier = getDataSetIdentifier(dataSetType, identifiers);
        this.type = dataSetType;
        this.paramName = identifier.paramName;
        this.paramValue = identifier.paramValue;
    }

    getIdentifierString() {
        return `DataSet_${this.type}_${this.paramName}_${this.paramValue}`;
    }
}

export default QuestionDataIdentifier;
